<template>
  <div class="canvas-invoice">
    <div class="img-preview-wrp">
      <div class="modal"></div>
      <img
        :style="{transform: `scale(${scale}) translate(${translateX}px, ${translateY}px)`}"
        id="previewImg"
        :src="img"
        class="img-wrp"
        ref="imgRef"
      />
    </div>
  </div>
</template>

<script>
import InvoiceSample from 'invoice-sample'
import Hammer from 'hammerjs'
export default {
  props: {
    invoiceData: {
      default: () => {},
      type: Object
    }
  },
  data () {
    return {
      img: '',
      hammerInstance: undefined,
      scale: 1,
      translateX: 0,
      translateY: 0
    }
  },
  computed: {

  },
  mounted () {
    this.draw(this.invoiceData)
    this.init()
  },
  methods: {
    init () {
      let dom = document.getElementById('previewImg')
      this.hammerInstance = new Hammer(dom)
      this.hammerInstance.get('pinch').set({ enable: true })
      this.hammerInstance.on('panmove', (e) => {
        this.translateX = e.deltaX
        this.translateY = e.deltaY
      })
      this.hammerInstance.on('pinchin', (e) => {
        this.scale = e.scale
      })
      this.hammerInstance.on('pinchout', (e) => {
        this.scale = e.scale
      })
    },
    draw (data) {
      data.details = data.sellerInvoiceDetails
      data.specificElementVO = data.specificElements || []
      let invoiceSample = new InvoiceSample({ data })
      this.img = invoiceSample.getInvoiceSample({ showSample: true })
      if (Number(data.invoiceType) === 7 || Number(data.invoiceType) === 8) { // 是否是数电发票
        this.img = invoiceSample.getFullElectricity({ showSample: true })
      }
    }
  },
  beforeDestroy () {
    this.$store.commit('invoice/initApplyData')
    this.$store.commit('invoice/changeGoodsList', [])
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
